import React, { Component } from "react";
import Joi from "joi-browser";

import Input from "./input";
import Select from "./select";
import Select2 from "./select2"; 

class Form extends Component {
  state = {
    data: {},
    errors: {}
  };

  validate = () => {
    const options = { abortEarly: false };
    const { error } = Joi.validate(this.state.data, this.schema, options);
    if (!error) return null;

    const errors = {};
    for (let item of error.details) errors[item.path[0]] = item.message;
    return errors;
  };

  validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const schema = { [name]: this.schema[name] };
    const { error } = Joi.validate(obj, schema);
    return error ? error.details[0].message : null;
  };

  handleSubmit = e => {
    e.preventDefault();
    console.log("Handle Submit");
    const errors = this.validate();
    this.setState({ errors: errors || {} });
    //if (errors) return;
    this.doSubmit();
  };

  handleChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];

    const data = { ...this.state.data };
    data[input.name] = input.value;
    //console.log("Data in Handle Change", data.performFunction);
    this.setState({ data, errors });
  };

  renderButton(label) {
    return (
      <button
        //  disabled={this.validate()}
        className="basicButton"
        style={{ width: 220 }}
      >
        {label}
      </button>
    );
  }

  renderSelect(name, label, options, optionsCompanyUsers) {
    const { data, errors } = this.state;
  

    return (
      
      <Select
        name={name}
        value={data[name]}
        label={label}
        options={options}
        optionsCompanyUsers={this.state.optionsCompanyUsers}
        onChange={this.handleChange}
        error={errors[name]}
      />
    );
  }

  renderSelect2(name, label, options, optionsCompanyUsers) {
    const { data, errors } = this.state;
  

    return (
      
      <Select2
        name={name}
        value={data[name]}
        label={label}
        options={options}
        optionsCompanyUsers={this.state.optionsCompanyUsers}
        onChange={this.handleChange}
        error={errors[name]}
      />
    );
  }

  renderInput(name, label, type) {
    const { data, errors } = this.state;
    return (
      <Input
        className="faridFormStyle"
        type={type}
        name={name}
        value={data[name]}
        label={label}
        onChange={this.handleChange}
        error={errors[name]}
      />
    );
  }
}

export default Form;
//className="btn btn-primary btn-sm"
